import ReactDiffViewer, {DiffMethod} from "react-diff-viewer-continued";
import React from "react";
import './JSONObjectComparer.scss';

type JSONObjectComparerProps = {
    oldValue: string;
    newValue: string;
    leftTitle?: string;
    rightTitle?: string;
};

const JSONObjectComparer = ({
                                oldValue,
                                newValue,
                                rightTitle = "New code",
                                leftTitle = "Old code"
                            }: JSONObjectComparerProps) => (
    <ReactDiffViewer
        oldValue={oldValue}
        newValue={newValue}
        splitView
        compareMethod={"diffJson" as DiffMethod}
        leftTitle={<div className="middle-title">{leftTitle}</div>}
        rightTitle={<div className="middle-title">{rightTitle}</div>}
    />
);

export default JSONObjectComparer;